import * as React from 'react';

import {CustomerSelectorPageContainer} from './containers';

export const CustomerSelectorPage: React.FC = () => {
    return (
        <CustomerSelectorPageContainer />
    );
};
